import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/inventario/general',
    },
    {
        path: 'dashboard',
        loadChildren: () => import('modules/dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule),
    },
    {
        path: 'pos',
        loadChildren: () => import('modules/pos/pos-routing.module').then(m => m.PosRoutingModule),
    },
    {
        path: 'inventario',
        loadChildren: () => import('modules/inventario/inventario-routing.module').then(m => m.InventarioRoutingModule),
    },
    {
        path: 'cuenta',
        loadChildren: () => import('modules/account/account-routing.module').then(m => m.AccountRoutingModule),
    },
    {
        path: 'accounts',
        loadChildren: () => import('modules/bank-accounts/bank-accounts-routing.module').then(m => m.BankAccountsRoutingModule),
    },
    {
        path: 'expenses',
        loadChildren: () => import('modules/expenses/expenses-routing.module').then(m => m.ExpensesRoutingModule),
    },
    {
        path: 'comercio',
        loadChildren: () => import('modules/commerce/commerce-routing.module').then(m => m.CommerceRoutingModule),
    },
    {
        // Recaudos fiscal v2: onboarding a Facturación Digital (menú Configuración › Fiscal).
        path: 'fiscal',
        loadChildren: () => import('modules/fiscal-onboarding/fiscal-onboarding-routing.module').then(m => m.FiscalOnboardingRoutingModule),
    },
    {
        path: 'financial-summary',
        loadChildren: () => import('modules/financial-summary/financial-summary-routing.module').then(m => m.FinancialSummaryRoutingModule),
    },
    {
        path: 'marketing',
        loadChildren: () => import('modules/marketing/marketing-routing.module').then(m => m.MarketingRoutingModule),
    },
    {
        path: 'statistics',
        loadChildren: () => import('modules/statistics/statistics-routing.module').then(m => m.StatisticsRoutingModule),
    },
    {
        path: 'asistente',
        loadChildren: () => import('modules/assistant/assistant-routing.module').then(m => m.AssistantRoutingModule),
    },
    {
        path: 'productos-bancarios',
        loadChildren: () => import('modules/bank-products/bank-products-routing.module').then(m => m.BankProductsRoutingModule),
    },
    {
        path: 'creditos',
        loadChildren: () => import('modules/creditos/creditos-routing.module').then(m => m.CreditosRoutingModule),
    },
    {
        path: 'initial-commerce',
        loadChildren: () => import('modules/initial-commerce/initial-commerce-routing.module').then(m => m.InitialCommerceRoutingModule),
    },
    {
        path: 'pipes',
        loadChildren: () => import('modules/pipes/pipes-routing.module').then(m => m.PipesRoutingModule),
    },
    {
        path: 'auth',
        loadChildren: () => import('modules/auth/auth-routing.module').then(m => m.AuthRoutingModule),
    },
    {
        path: 'legal',
        loadChildren: () => import('modules/legal/legal-routing.module').then(m => m.LegalRoutingModule),
    },
    {
        path: 'error',
        loadChildren: () => import('modules/error/error-routing.module').then(m => m.ErrorRoutingModule),
    },
    {
        path: '**',
        pathMatch: 'full',
        loadChildren: () => import('modules/error/error-routing.module').then(m => m.ErrorRoutingModule),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            relativeLinkResolution: 'legacy',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
